// API Configuration
export const API_BASE_URL = (window._env_ && window._env_.REACT_APP_API_BASE_URL) || process.env.REACT_APP_API_BASE_URL || "http://localhost:3010";

export const API_ENDPOINTS = {
  // Auth endpoints
  LOGIN: "/v1/auth/login",
  LOGOUT: "/v1/auth/logout",
  ME: "/v1/auth/me",
  // Node endpoints
  NODES_WITHOUT_METADATA: "/v1/nodes/without-metadata",
  // Alternative endpoints to try
  NODES_WITHOUT_METADATA_ALT: "/without-metadata",
  NODES_WITHOUT_METADATA_ALT2: "/nodes/without-metadata",
  // Equipment endpoints
  CREATE_EQUIPMENT: "/v1/equipment",
  GET_EQUIPMENT: "/v1/equipment",
  // Node metadata endpoints
  ADD_METADATA_TO_NODE: "/v1/nodes/metadata",
  // Node inventory endpoints
  GET_NODE_INVENTORY: "/v1/nodes/inventory",
  // Node details endpoint
  GET_NODE_DETAILS: "/v1/nodes/details",
  // Node details by ID for editing
  GET_NODE_DETAILS_BY_ID: "/v1/nodes/info/for/node",
  // Update node with metadata
  UPDATE_NODE_WITH_METADATA: "/v1/nodes/info/for/node",
};
